














































































































































import {
  Component,
  Emit,
  Prop,
  PropSync,
  Ref,
  Watch
} from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  Alert,
  AlertMessage,
  collectionApi,
  defaultSystemCode,
  ErrorMessage,
  lendApi,
  LendCollection,
  remindHistoriesApi,
  RemindHistory,
  SimpleCollection,
  SystemCode,
  userApi
} from '@/api'
import {
  alertStore,
  authUserStore,
  modalErrorStore,
  systemCodeStore,
  systemParameterStore
} from '@/utils/store-accessor'
import { ModalLostProcedure } from '@/components/modals/ModalLostProcedure'
import RemindHistoryTable from '@/components/organisms/RemindHistoryTable/RemindHistoryTable.vue'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import { AlertFactory } from '@/factory'
import LendOutCollectionTable from '@/components/organisms/LendOutCollectionTable/LendOutCollectionTable.vue'
import LendOutCollectionButtonToggle from '@/components/organisms/LendOutCollectionButtonToggle/LendOutCollectionButtonToggle.vue'
import { ModalLendExtend } from '@/components/modals/ModalLendExtend'
import { ModalReminderInput } from '@/components/modals/ModalReminderInput'
import { includes } from 'lodash'
import {
  AlertCodeAL400022,
  AlertCodeWAR00002,
  AlertCodeILC00005,
  AlertCodeILC00021,
  AlertCodeILC00023,
  AlertCodeTL200007,
  UserDetailStateInfo
} from '@/types'
import { InputCode } from '@/components/molecules/InputCode'
import { InputCollectionNo } from '@/components/molecules/InputCollectionNo'
import { printLendStatusReceipt } from '@/utils/receipt'

export interface UserContentLendingItem {
  id: string
  name: string
  revision: number
  userType: SystemCode
  lendCollections: LendCollection[]
  remindHistories: RemindHistory[]
}

export const defaultUserContentLendingItem = (): UserContentLendingItem => ({
  id: '',
  name: '',
  revision: 0,
  userType: defaultSystemCode(),
  lendCollections: [],
  remindHistories: []
})

@Component({
  components: {
    InputCollectionNo,
    InputCode,
    ModalReminderInput,
    ModalLendExtend,
    LendOutCollectionButtonToggle,
    LendOutCollectionTable,
    RemindHistoryTable,
    ModalLostProcedure
  }
})
export default class UserContentLending extends ComponentVue {
  @Ref()
  inputCollectionNo!: InputCollectionNo

  @Ref()
  modalLendExtend!: ModalLendExtend

  @Ref()
  modalReminderInput!: ModalReminderInput

  @Ref()
  modalLostProcedure!: ModalLostProcedure

  @Ref()
  lendOutCollectionTable!: LendOutCollectionTable

  @Ref()
  remindHistoryTable!: RemindHistoryTable

  @PropSync('item', {
    type: Object,
    required: true
  })
  contentItem!: UserContentLendingItem

  @Prop({
    type: Object,
    required: true
  })
  state!: UserDetailStateInfo

  @Prop({
    type: Number,
    required: true
  })
  height!: number

  @Prop({
    type: Boolean,
    default: false
  })
  titleLink!: boolean

  @Prop({
    type: Boolean,
    default: false
  })
  editTable!: boolean

  activeToggleItem: string = '1'

  checkedCollectionIds: number[] = []

  inputtedLibraryBranchCode: string = ''

  inputtedSearchCollectionNo: string = ''

  isAllSelect: boolean = false

  get showLendItems(): LendCollection[] {
    if (this.inputtedLibraryBranchCode === '') {
      return this.contentItem.lendCollections
    }

    const branchCode = this.libraryBranchSystemCodes.find(item => {
      return item.code === this.inputtedLibraryBranchCode
    })

    if (branchCode) {
      return this.contentItem.lendCollections.filter(item => {
        return item.branch.code === this.inputtedLibraryBranchCode
      })
    }

    return this.contentItem.lendCollections
  }

  get selectLendItems(): LendCollection[] {
    return this.contentItem.lendCollections.filter(item => {
      return this.checkedCollectionIds.includes(item.id)
    })
  }

  get libraryBranchSystemCodes(): SystemCode[] {
    return systemCodeStore.getLibraryBranch
  }

  get showLending(): boolean {
    return this.activeToggleItem === '1'
  }

  get isAuthUserGroupBibliographyOnlyReference(): boolean {
    return authUserStore.isAuthUserGroupBibliographyOnlyReference
  }

  get existsLendCollectionList(): boolean {
    return this.contentItem.lendCollections.length > 0
  }

  get usingAppendixLendManagement(): boolean {
    return systemParameterStore.usingAppendixLendManagement
  }

  @Watch('state.state')
  onChangeState(): void {
    this.lendOutCollectionTable.onSort({
      name: '',
      order: ''
    })
    this.remindHistoryTable.onSort({
      name: '',
      order: ''
    })
  }

  @Watch('contentItem')
  initialize(): void {
    this.isAllSelect = false
  }

  @Watch('isAllSelect')
  toggleCheckedCollectionIds(): void {
    if (this.isAllSelect) {
      this.checkedCollectionIds = this.contentItem.lendCollections.map(item =>
        Number(item.id)
      )
    } else {
      this.checkedCollectionIds = []
    }
  }

  @Watch('showLending')
  onToggleDisplayTable(): void {
    if (this.editTable && this.showLending) {
      this.$nextTick(this.focusCollectionNo)
    }
  }

  focusCollectionNo(): void {
    this.inputCollectionNo.focus()
  }

  onChangeCheckedCollectionIds(collectionId: number): void {
    const index = this.checkedCollectionIds.indexOf(collectionId)
    if (index !== -1) {
      this.checkedCollectionIds.splice(index, 1)
    } else {
      this.checkedCollectionIds.push(collectionId)
    }
  }

  onClickAllSelect(value: boolean): void {
    this.isAllSelect = value
  }

  onClickReceiptPrint(): void {
    printLendStatusReceipt(
      this.showLendItems,
      this.checkedCollectionIds,
      this.contentItem.id,
      this.contentItem.userType
    )
  }

  onClickLendExtend(): void {
    this.modalLendExtend.open()
  }

  onClickRemind(): void {
    if (this.checkedCollectionIds.length === 0) {
      const alert: Alert = AlertFactory.create(
        AlertCodeILC00005,
        '督促',
        '資料'
      )
      alertStore.setItem(alert)
      this.$modalAlert.open()
      return
    }

    this.modalReminderInput.open({
      userId: this.contentItem.id,
      lendCollections: this.selectLendItems,
      onUpdated: () => {
        this.isAllSelect = false
        this.checkedCollectionIds = []
        this.onUpdated()
      }
    })
  }

  onClickLostProcedures(): void {
    if (this.checkedCollectionIds.length === 0) {
      const alert: Alert = AlertFactory.create(
        AlertCodeILC00005,
        '紛失手続',
        '資料'
      )
      alertStore.setItem(alert)
      this.$modalAlert.open()
      return
    }

    this.modalLostProcedure.open()
  }

  onClickCollectionEdit(): void {
    const alerts: Alert[] = []

    if (this.checkedCollectionIds.length === 0) {
      alerts.push(AlertFactory.create(AlertCodeILC00021, '資料情報'))
    }

    if (this.checkedCollectionIds.length > 1) {
      alerts.push(AlertFactory.create(AlertCodeILC00023, '資料情報'))
    }

    if (alerts.length > 0) {
      alertStore.setItems(alerts)
      this.$modalAlert.open()
      return
    }

    this.$modalCollectionEdit.open({
      collectionId: this.selectLendItems[0].id,
      bibliographyRealId: this.selectLendItems[0].bibliographyId,
      onUpdateClosed: async () => {
        this.contentItem.lendCollections = (
          await userApi.getUserLendCollectionsById(this.contentItem.id)
        ).collections
      }
    })
  }

  onUpdatedLostProcedure() {
    this.isAllSelect = false
    this.checkedCollectionIds = []
    this.onUpdated()
  }

  onClickRemove(id: number): void {
    const alert: Alert = AlertFactory.create(AlertCodeAL400022)
    alertStore.setItem(alert)
    this.$modalAlert.open({
      onOkClick: () => {
        this.deleteRemindHistory(id)
      }
    })
  }

  async getSimpleCollection(): Promise<void> {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      const collections: SimpleCollection[] = await collectionApi.getSimpleCollections(
        {
          collectionNo: this.inputtedSearchCollectionNo
        }
      )

      this.$modalCollectionSelect.open({
        collectionNo: this.inputtedSearchCollectionNo,
        simpleCollections: collections,
        onClickOk: (id: number) => {
          if (!includes(this.checkedCollectionIds, id)) {
            this.checkedCollectionIds.push(id)
            this.$nextTick(() => {
              this.inputtedSearchCollectionNo = ''
            })
          }
        }
      })
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  onDetermineCollectionNo(): void {
    const collections: LendCollection[] = this.contentItem.lendCollections.filter(
      value => value.collectionNo === this.inputtedSearchCollectionNo
    )

    if (collections.length === 0) {
      const alert: Alert = AlertFactory.create(
        AlertCodeTL200007,
        this.inputtedSearchCollectionNo,
        '貸出されていない資料',
        '選択'
      )
      alertStore.setItem(alert)
      this.$modalAlert.open({
        onOkClick: () => this.$nextTick(this.focusCollectionNo)
      })
      return
    }

    if (collections.length === 1) {
      if (!includes(this.checkedCollectionIds, collections[0].id)) {
        this.checkedCollectionIds.push(collections[0].id)
        this.$nextTick(() => (this.inputtedSearchCollectionNo = ''))
      }
      return
    }

    if (collections.length > 1) {
      this.getSimpleCollection()
    }
  }

  onChangeAppendixLend(index: number): void {
    this.$nextTick(() => {
      alertStore.setItem(
        AlertFactory.create(
          AlertCodeWAR00002,
          systemParameterStore.isDisplayAlertTitleOnLendReturn
            ? this.showLendItems[index].displayTitle
            : this.showLendItems[index].collectionNo,
          this.showLendItems[index].appendixLendFlag ? '返却' : '貸出'
        )
      )

      this.$modalAlert.open({
        onOkClick: () => {
          if (this.showLendItems[index].appendixLendFlag) {
            this.returnAppendix(index)
          } else {
            this.lendAppendix(index)
          }
        }
      })
    })
  }

  async lendAppendix(index: number): Promise<void> {
    try {
      await lendApi.lendAppendix({
        collectionId: this.showLendItems[index].id,
        revision: this.showLendItems[index].revision
      })
      this.showLendItems[index].appendixLendFlag = !this.showLendItems[index]
        .appendixLendFlag

      this.onUpdated()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }

  async returnAppendix(index: number): Promise<void> {
    try {
      await lendApi.returnAppendix({
        collectionId: this.showLendItems[index].id,
        revision: this.showLendItems[index].revision
      })
      this.showLendItems[index].appendixLendFlag = !this.showLendItems[index]
        .appendixLendFlag

      this.onUpdated()
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open()
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }

  async deleteRemindHistory(id: number) {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await remindHistoriesApi.delete(id)
      this.contentItem.remindHistories = await userApi.getRemindHistory(
        this.contentItem.id
      )
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  @Emit('toggled:table')
  setActiveToggleItem(value: string): void {
    this.activeToggleItem = value
  }

  @Emit('updated')
  onUpdated(): void {}

  @Emit('updated:lend-extend')
  onUpdatedLendExtend(): void {
    this.isAllSelect = false
    this.checkedCollectionIds = []
  }
}
